import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { WhatsAppButton } from "./WhatsAppButton";
import { LayoutProvider } from "@/context/LayoutContext";

export function SiteLayout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <LayoutProvider>
      <div className="min-h-screen bg-cream">
        <Header />
        <main>
          <Outlet />
        </main>
        <Footer />
        <WhatsAppButton />
      </div>
    </LayoutProvider>
  );
}
